import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getWriteFromDictation = (params) => {
	var url = ApiRouters.WRITEFROMDICTATION;
	return api.get(url, { params });
};

export const getWriteFromDictationDetail = (id, params) => {
	var url = `${ApiRouters.WRITEFROMDICTATION}/${id}`;
	return api.get(url, { params });
};

export const createQuesWriteFromDictation = (body) => {
	var url = ApiRouters.WRITEFROMDICTATION;
	return api.post(url, body);
};

export const updateWriteFromDictationDetail = (body) => {
	var url = `${ApiRouters.WRITEFROMDICTATION}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteWriteFromDictation = (id) => {
	var url = `${ApiRouters.WRITEFROMDICTATION}/${id}`;
	return api.delete(url);
};
